<template>
    <div class="content">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
            <Row>
                <!-- 当Form中只有一个input时回车会自动提交表单，这是浏览器的默认行为。 -->
                <Col span="4">
                    <FormItem label="关键字" class="mb-10" style="95%">
                       <Input v-model="listQuery.task_name"  placeholder="请输入任务名称" @keydown.native.enter.prevent ="handleEnter" />
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="客户类型" class="mb-10" style="95%">
                        <Select  v-model="listQuery.client_type_id"   placeholder="请选择客户类型"    >
                            <Option v-for="item in userTypeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="时间点" class="mb-10" style="95%">
                        <Select v-model="listQuery.timing_id"   placeholder="请选择时间点">
                            <Option v-for="item in timeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem :label-width="0" class="mb-10" style="margin-left:10px">
                        <Button   type="primary" icon="ios-search" @click="searchList">查询</Button>
                        <Button  type="primary" icon="ios-search" @click="emptyFilter">清空筛选</Button>
                        <Button   icon="ios-add" type="primary" @click="addTask">新增任务</Button>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div class="table_wrap">
            <div style="width:100%">
                <Table   stripe border ref="table"
                    :height="tableHeight"
                    :loading="tabLoading"  
                    :columns="tabColumns" 
                    :data="tabData"
                ></Table>
                <div style="margin-top:20px;display:flex;justify-content:flex-end">
                    <Page show-total show-elevator show-sizer  :page-size-opts="pageSizeOpts" :page-size="50"
                        :total="total"  :current="listQuery.page"
                        :transfer="true"
                        @on-change="changePage" 
                        @on-page-size-change="changeLimit"/>
                </div>
            </div>
        </div>

         <!-- 添加|编辑任务对话框 -->
        <Modal
            v-model="showAddTask"
            :closable="false"
            :mask-closable="false"
            class-name="vertical-center-modal">
                <p slot="header" class="modal_title">
                    <span>{{isModalTitle==1?'新增任务':(isModalTitle==2?'修改任务':'')}}</span>
                </p>
                <Form  ref="addTaskForm" :model="addTaskForm" :rules="addTaskFormRule" :label-width="80" >
                    <FormItem label="任务名称" prop="task_name">
                        <Input v-model="addTaskForm.task_name" style="width:90%" :maxlength="50"   placeholder="请在50字内填写"></Input>
                    </FormItem>
                    <FormItem label="客户类型" prop="client_type">
                        <Select v-model="addTaskForm.client_type"   style="width:90%" placeholder="请选择客户类型" >
                            <Option v-for="item in userTypeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="任务对象" prop="task_object">
                        <Select v-model="addTaskForm.task_object"   style="width:90%" placeholder="请选择任务对象" >
                            <Option v-for="item in taskObjectList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="时间点" prop="timing">
                        <Select v-model="addTaskForm.timing"   style="width:90%" placeholder="请选择时间点" >
                            <Option v-for="item in timeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="间隔(天)" prop="interval_day">
                        <Select v-model="addTaskForm.interval"   style="width:30%" placeholder="请选择" >
                            <Option value="1">前</Option>
                            <Option value="2">后</Option>
                        </Select>
                        <!-- <InputNumber  :min="1" placeholder="请输入整数" v-model="addTaskForm.interval_day" style="width:90%"></InputNumber>             -->
                        <!--  :change="check_num()" -->
                        <Input v-model="addTaskForm.interval_day"
                           
                            style="width:59%"   placeholder="请输入整数"></Input>
                    </FormItem>
                    <FormItem label="回访任务" prop="desc">
                        <Input style="width:90%"  type="textarea"  :autosize="{minRows: 2,maxRows: 5}"
                        v-model="addTaskForm.desc"  
                        placeholder="请在500字内描述回访任务"
                        :maxlength="500"
                        ></Input>
                    </FormItem>
                     <FormItem label="状态" prop="status">
                        <RadioGroup v-model="addTaskForm.status"  style="width:90%" >
                            <Radio  label='1'>启用</Radio>
                            <Radio  label='2'>停用</Radio>
                        </RadioGroup>
                    </FormItem>
                </Form>

                <div slot="footer">
                    <Button type="primary" size="large"  @click="handleSubmit('addTaskForm')">确定</Button>
                    <Button  size="large"  @click="handleReset('addTaskForm')">取消</Button>
                </div>
        </Modal>
      
    </div>
</template>
<script>
// interval
let onlyNum=function(rule,value,cb){
    let Reg=/^[1-9]\d*$/g;
    if(!Reg.test(value)&&value!==''){
        cb(new Error('请输入大于0的整数'));
    }else{
        cb();
    }
}
export default {
    name:'returnTaskSetting',
    data(){
        return{
            userTypeList:[{id:"1",name:'全部类型'},{id:"2",name:'待成交'},{id:"3",name:'已签单'},{id:"4",name:'已放弃'}],
            timeList:[{id:"1",name:'签单日期'},{id:"2",name:'上次回访日期'},{id:"3",name:'预产期'},{id:"4",name:'离院日期'}],
            taskObjectList:[{id:"1",name:'签单人'},{id:"2",name:'跟进人'},{id:"3",name:'录入人'}],
            showAddTask:false,  
            tabLoading:false,
            tableHeight:650,
            tabData:[],
            tabColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '任务名称',
                        key: 'task_name',
                        align:'center',
                    },
                    {
                        title: '客户类型',
                        key: 'client_type',
                        align:'center',
                        width:120
                    },
                    {
                        title: '任务对象',
                        key: 'task_object',
                        align:'center',
                        width:120
                    },
                    {
                        title: '时间点',
                        key: 'timing',
                        align:'center',
                        width:120
                    },
                    {
                        title: '间隔（天）',
                        key: 'interval_day',
                        align:'center',
                        width:120
                    },
                    {
                        title: '回访任务',
                        key: 'desc',
                        align:'center',
                    },
                    {
                        title: '状态',
                        key: 'status',
                        align:'center',
                        width:120
                    },
                    {
                        title: '操作',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.isModalTitle=2
                                            this.isEditorTaskId=params.row.id
                                            this.apiTaskDetails(params.row.id)
                                        }
                                    }
                                }, '修改')
                            ]);
                        }
                    }
                ],
           
            // 列表查询参数
            listQuery:{
                page:1,
                limit:50,
                timing_id:'',
                client_type_id:'',
                task_name:''
            },
            total:0,
            pageSizeOpts:[50,60,70,80,90,100],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            stylesModal:{
                height: '500px',
                overflow: 'auto',
                // position: 'static'
            },
            isModalTitle:1,
            isEditorTaskId:'',
            addTaskForm:{
                task_name:'',
                client_type:'',
                task_object:'',
                timing:'',
                interval_day:'',
                desc:'',
                status:'1',
                interval:'1'
            },
            addTaskFormRule:{
                task_name: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' }
                ],
                client_type: [
                    { required: true, message: '请选择用户类型', trigger: 'change',type:'string'}
                ],
                task_object: [
                    { required: true, message: '请选择任务对象', trigger: 'change',type:'string'}
                ],
                timing: [
                    { required: true, message: '请选择时间点', trigger: 'change',type:'string'}
                ],
                interval_day: [
                    // { required: true, message: '请选择间隔天数', trigger: 'change' }
                    {validator:onlyNum,trigger:'blur',required: true,}
                    //  { required: true, message: '最小分不能为空',},
                    // { message: '最小分只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}

                ],
                desc:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { type: 'string', max: 500, message: '备注不能大于500字', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ],
            }
        }
    },
    created(){
        this.getList()
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220
    },
    methods:{
        handleEnter(){
            return false;
        },   
        // 任务详情
        apiTaskDetails(id){
            serve.fetchGet(api.getReturnTaskDetail+'/'+id,{}).then(res => {
                this.addTaskForm.task_name=res.data.task_name
                this.addTaskForm.client_type=res.data.client_type.toString()
                this.addTaskForm.task_object=res.data.task_object.toString()
                this.addTaskForm.timing=res.data.timing.toString()
                this.addTaskForm.status=res.data.status.toString()
                this.addTaskForm.interval=res.data.interval.toString()
                this.addTaskForm.interval_day=res.data.interval_day.toString()
                this.addTaskForm.desc=res.data.desc
                this.showAddTask=true
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        //  新增||修改任务
        apiAddTask(){
            let params=this.addTaskForm;
            if(this.isModalTitle==2)params.id=this.isEditorTaskId
            serve.fetchPost(api.saveReturnTask,params).then(res => {
                this.showAddTask=false
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        // 获取列表
        getList(){
            this.tabLoading=true
            serve.fetchGet(api.returnTaskList,this.listQuery).then(res => {
                var data=res.data;
                this.tabData=data
                this.total=res.meta.pagination.total
                this.tabLoading=false
            }).catch((err=>{
                this.tabLoading=false
                this.$Message.error(error.response.data.message);
            })) 
        },
        changePage(val){
            this.listQuery.page=val
            this.getList()
        },
        changeLimit(val){
            this.listQuery.limit=val
            this.getList()
        },
        
        // 清空筛选
        emptyFilter(){
            this.listQuery.page=1
            this.listQuery.task_name=''
            this.listQuery.client_type_id=''
            this.listQuery.timing_id=''
            this.getList()
        },
        // 查询
        searchList(){
            this.listQuery.page=1
            this.getList()
        },
        // 添加
        addTask(){
            this.$refs['addTaskForm'].resetFields();
            this.isModalTitle=1
            this.isEditorTaskId=''
            this.addTaskForm.task_name=''
            this.addTaskForm.client_type=''
            this.addTaskForm.task_object=''
            this.addTaskForm.timing=''
            this.addTaskForm.interval_day=''
            this.addTaskForm.desc=''
            this.addTaskForm.status='1'
            this.addTaskForm.interval='1'
            this.showAddTask=true
        },   
        //限制正整数
        check_num(){
            var interval_day = this.addTaskForm.interval_day;
            interval_day = interval_day.replace(/[^\d]/g, ''); 
            if (interval_day.indexOf('.') < 0 && interval_day != '') {
               
                interval_day = parseInt(interval_day);
                console.log('parseInt(interval_day)',interval_day)
            }
            this.addTaskForm.interval_day = interval_day.toString();
             console.log('interval_day.toString()',this.addTaskForm.interval_day)
        },
        // 确认
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    switch(name){
                        case 'addTaskForm':
                            switch(this.isModalTitle){
                                case 1:
                                    this.apiAddTask()
                                break;
                                case 2:
                                    this.apiAddTask()
                                break;
                            }
                        break;
                      
                    }
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        // 取消
        handleReset (name) {
            this.$refs[name].resetFields();
            switch(name){
                case 'addTaskForm':
                    this.showAddTask=false
                break;
               
            }
        }
    }
}
</script>
<style>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
.ivu-table-cell {
    white-space: pre-line!important;
}
.ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
.opertionBtn{
    margin-bottom:20px;
    display:flex;
    display: -webkit-flex;
    align-items: center
}
.opertionBtn .item{
    margin-right: 5px
}
.mb-10{
    margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/ReturnManagement/returnTaskSetting.vue